import "./SuccessStoriesSpeakForThemselves.css";
import { useState, useEffect } from "react";
import config from "../../../config";
import carouselForDesktop from "./SuccessStoriesDesktopCarousel";
import carouselForMobile from "./SuccessStoriesMobileCarousel";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useIsMobile } from "../../../hooks/useIsMobile";

export interface SuccessStory {
  id: number;
  coordinatorName: string;
  briefHeader: string;
  detailedDescription: string;
  imageURL: string;
  campaignDuration: string;
  totalRaised: string;
  totalSupporters: number;
}
const RETURN_AMOUNT = 5;

const SuccessStoriesSpeakForThemselves = () => {
  const [successStories, setSuccessStories] = useState<SuccessStory[]>([]);
  const isMobile = useIsMobile();

  useEffect(() => {
    const fetchSuccessStories = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}success-stories?returnAmount=${RETURN_AMOUNT}`,
        );

        if (response.ok) {
          const data: SuccessStory[] = await response.json();
          setSuccessStories(data);
        } else {
          setSuccessStories([]); // Handle error or empty
        }
      } catch (error) {
        console.error("Error fetching success stories:", error);
        setSuccessStories([]); // Handle error
      }
    };

    fetchSuccessStories();
  }, []);

  return (
    <div className="success-stories-container">
      <div style={{ textAlign: "center" }}>
        <h2 style={{ color: "var(--homepage-main-background-1)" }}>
          Success Stories
        </h2>{" "}
        <h2>That Speak For Themselves</h2>
      </div>
      {isMobile
        ? carouselForMobile(successStories)
        : carouselForDesktop(successStories)}
    </div>
  );
};

export default SuccessStoriesSpeakForThemselves;
